import { computed as u, openBlock as a, createElementBlock as d, normalizeClass as f, unref as r, createElementVNode as b, toDisplayString as g, createBlock as o, createCommentVNode as n } from "vue";
import i from "../../../atoms/icon/icon.vue.js";
import k from "../../../atoms/icon-loader/icon-loader.vue.js";
import { FORM_SUBMIT_STATE as t, FORM_SUBMIT_COLOR as c } from "../constants.js";
/* empty css                 */
const y = ["aria-label", "disabled"], p = /* @__PURE__ */ Object.assign({
  name: "DsFormButton"
}, {
  __name: "form-button",
  props: {
    /**
     * Button label
     */
    label: {
      type: String,
      required: !0
    },
    /**
     * Button state, controls styling
     */
    state: {
      type: String,
      default: t.start,
      validator(e) {
        return Object.values(t).includes(e);
      }
    },
    color: {
      type: String,
      default: c.green,
      validator(e) {
        return [c.green, c.black].includes(e);
      }
    }
  },
  setup(e) {
    const s = e, m = u(() => {
      let l = [t.loading, t.fail, t.disabled].includes(s.state) ? `ds-form-button--${s.state}` : "";
      return s.color !== "black" && (l += " ds-form-button--black"), l;
    });
    return (l, S) => (a(), d("button", {
      type: "submit",
      "aria-label": e.label,
      class: f(["ds-form-button", m.value]),
      disabled: e.state === r(t).disabled
    }, [
      b("span", null, g(e.label), 1),
      e.state === r(t).success ? (a(), o(i, {
        key: 0,
        category: "interface",
        name: "checkmarkSmall",
        class: "ds-margin-left-12"
      })) : n("", !0),
      e.state === r(t).fail ? (a(), o(i, {
        key: 1,
        category: "interface",
        name: "cross",
        class: "ds-margin-left-12"
      })) : n("", !0),
      e.state === r(t).loading ? (a(), o(k, {
        key: 2,
        class: "ds-margin-left-12"
      })) : n("", !0)
    ], 10, y));
  }
}), F = p;
export {
  F as default
};
